import { atom } from 'recoil';

export const isWhiteModalContainerOpenState = atom<boolean>({
  key: 'isWhiteModalContainerOpen',
  default: false,
});
